import React from "react";
import "./Header.css";

function Header() {
  return (
    <header className="header-container">
      <div className="header-content">
        <h1 className="header-title">Invoice Payment</h1>
        <p className="header-subtitle">Pay your invoices quickly and easily!</p>
      </div>
    </header>
  );
}

export default Header;
